import React from 'react';
import {
  CfaData,
  getDivisionsByCfaId,
  getSelectedCfas,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../../common';
import { SVGS } from '../../../assets';
import { hash } from '@zonofi/common/functions';
import { Divider } from '../../../components';
import './cfa-card.scss';

interface CFACardProps {
  data: CfaData;
  onCfaSelect?: (cfa: CfaData) => void;
  onAssignDivisions?: (cfa: CfaData) => void;
  onEditPress?: (cfa: CfaData) => void;
}

const cfaColors = [
  { background: '#FFD1DC' },
  { background: '#DCE1EA' },
  { background: '#E2F8F5' },
  { background: '#E2F1F8' },
  { background: '#F8E2E2' },
  { background: '#FDF6D6' },
];

export const CFACard: React.FC<CFACardProps> = ({
  data,
  onCfaSelect,
  onAssignDivisions,
  onEditPress,
}) => {
  const selectedColor = cfaColors[hash(data?.supplierName, cfaColors.length)];
  const divisionByCfa = useAppSelector((state) =>
    getDivisionsByCfaId(state, data?.id)
  );
  const selectedCfa = useAppSelector(getSelectedCfas);
  const isSelected = selectedCfa?.some((cfa) => cfa.id === data?.id);

  return (
    <div className="cfa-item__container">
      <div className="cfa-item__container-selected">
        <TouchableOpacity
          key={data?.id}
          className="cfa-item__view"
          onPress={() => onCfaSelect?.(data)}
        >
          <img src={isSelected ? SVGS.CheckboxBlack : SVGS.UncheckedBox} />
          <div
            className="cfa-item__view--cfa-icon"
            style={{ backgroundColor: selectedColor.background }}
          >
            <img src={SVGS.CfasIcon} />
          </div>

          <div className="cfa-item__info">
            <div className="cfa-item__info--title font-semibold">
              {data?.supplierName}
            </div>
            <div className="cfa-item__info--phone">
              <img src={SVGS.PhoneIcon} />
              <div className="cfa-item__info--sub-title font-regular">
                {data?.phone?.slice(2)}
              </div>
            </div>
          </div>
        </TouchableOpacity>

        {divisionByCfa?.length > 0 && (
          <TouchableOpacity onPress={() => onEditPress?.(data)}>
            <img src={SVGS.PencilIcon} />
          </TouchableOpacity>
        )}
      </div>

      {isSelected && (
        <>
          <Divider className="cfa-item--divider-style" />
          {divisionByCfa?.length > 0 ? (
            <div className="cfa-item--selected-text font-regular">{`${divisionByCfa?.length} Divisions Selected`}</div>
          ) : (
            <TouchableOpacity
              className="cfa-item---bottom-view"
              onPress={() => onAssignDivisions?.(data)}
            >
              <img src={SVGS.AddCircle} />
              <div className="cfa-item---bottom-view__text font-semibold">
                {'Assign Divisions'}
              </div>
            </TouchableOpacity>
          )}
        </>
      )}
    </div>
  );
};
